module.exports = __webpack_public_path__ + "static/img/mask.12089dfc.png";